export enum ProcessDumpType {
    Full = "Full",
    Heap = "Heap",
    Mini = "Mini"
}